import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tile, TileGroup } from '../../../../components/Tiles';
import {
    BUSINESS_EVENTBRITE_CATEGORY,
    CATEGORY_LONG_NAME_ICON_MAP,
    EVENTBRITE_CATEGORY_MAPPING,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
    TRAVEL_EVENTBRITE_CATEGORY,
} from '../../../../constants';
import './CategoryTiles.scss';

const CATEGORIES = [
    {
        key: MUSIC_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[MUSIC_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[MUSIC_EVENTBRITE_CATEGORY],
    },
    {
        key: PERFORMING_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[PERFORMING_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[PERFORMING_EVENTBRITE_CATEGORY],
    },
    {
        key: TRAVEL_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[TRAVEL_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[TRAVEL_EVENTBRITE_CATEGORY],
    },
    {
        key: HEALTH_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[HEALTH_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[HEALTH_EVENTBRITE_CATEGORY],
    },
    {
        key: HOBBIES_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[HOBBIES_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[HOBBIES_EVENTBRITE_CATEGORY],
    },
    {
        key: BUSINESS_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[BUSINESS_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[BUSINESS_EVENTBRITE_CATEGORY],
    },
    {
        key: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[FOOD_AND_DRINK_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[FOOD_AND_DRINK_EVENTBRITE_CATEGORY],
    },
    {
        key: SPORTS_EVENTBRITE_CATEGORY,
        name: EVENTBRITE_CATEGORY_MAPPING[SPORTS_EVENTBRITE_CATEGORY],
        icon: CATEGORY_LONG_NAME_ICON_MAP[SPORTS_EVENTBRITE_CATEGORY],
    },
];

//music arts travel health hobbies business

const CategoryTilesRaw: any = (props: { locationSlug: string }) => {
    return (
        <div className="home__category-tiles">
            <h3 className="home__category-tiles--title eds-text-hs">
                {gettext('Check out trending categories')}
            </h3>
            <TileGroup tiles={CATEGORIES}>
                {(tileContent) => (
                    <Link
                        to={`/d/${props.locationSlug}/browse/?tag=${tileContent?.key}`}
                        onClick={() => window.scrollTo(0, 0)}
                    >
                        <Tile
                            name={tileContent?.name}
                            icon={tileContent?.icon}
                        />
                    </Link>
                )}
            </TileGroup>
        </div>
    );
};

const _mapStateToProps = (state: {
    location?: {
        slug?: string;
    };
}) => ({
    locationSlug: state.location?.slug,
});
export const CategoryTiles = connect(_mapStateToProps)(CategoryTilesRaw);
